import {
  NavbarLeft,
  NavbarRight
} from '@/components/navbar/components/Containers'
import { InteractionIcons } from '@/components/navbar/components/InteractionIcons'
import { Logo } from '@/components/navbar/components/Logo'
import { StepProcess } from '@/components/navbar/components/StepProcess'
import { SubscriptionContent } from '@/components/navbar/components/Subscription'
import { Toggle } from '@/components/navbar/components/Toggle'
import NavbarComponent from './Navbar'
export * from './Navbar'

export const Navbar = Object.assign(NavbarComponent, {
  Logo,
  InteractionIcons,
  Left: NavbarLeft,
  Right: NavbarRight,
  Subscription: SubscriptionContent,
  StepProcess,
  Toggle
})

export default Navbar
